<address>
  {{address.HouseName}} {{address.HouseNumber}} {{address.Street1}} {{address.District}} {{address.PostTown}} {{address.Postcode}}
</address>
